enum ProxyDialogFields {
	HTTPS_ENABLED = "https_enabled",
	HTTPS_HOST = "https_host",
	HTTPS_PORT = "https_port",
	HTTPS_USER = "https_user",
	HTTPS_PASSWORD = "https_password",
	HTTP_ENABLED = "http_enabled",
	HTTP_HOST = "http_host",
	HTTP_PORT = "http_port",
	HTTP_USER = "http_user",
	HTTP_PASSWORD = "http_password"
}

export default ProxyDialogFields;